// icons
import { CiMoneyBill } from 'react-icons/ci';
import { FiAward } from 'react-icons/fi';
import { GiRank3 } from 'react-icons/gi';
import { GoClock } from 'react-icons/go';
import { GrLineChart } from 'react-icons/gr';
import { HiOutlineDocumentCheck } from 'react-icons/hi2';
import { RiComputerLine } from 'react-icons/ri';
import { SlEnvolopeLetter } from 'react-icons/sl';
import { TbHeartHandshake, TbSchool, TbPigMoney } from 'react-icons/tb';
import { TiArrowShuffle } from 'react-icons/ti';
import { VscArrowSwap } from 'react-icons/vsc';

export default {
  afforda: <TbPigMoney size={18} />,
  salary: <CiMoneyBill size={18} />,
  transcript: <HiOutlineDocumentCheck size={18} />,
  'transfer credits': <VscArrowSwap style={{ transform: 'rotate(135deg)' }} size={18} />,
  flexi: <TiArrowShuffle style={{ transform: 'rotate(270deg)' }} size={18} />,
  accredit: <FiAward size={18} />,
  length: <GoClock size={18} />,
  online: <RiComputerLine size={18} />,
  roi: <GrLineChart size={18} />,
  admission: <SlEnvolopeLetter size={18} />,
  military: <GiRank3 size={18} />,
  diversity: <TbHeartHandshake size={18} />,
  default: <TbSchool size={18} />,
};
